import { render, staticRenderFns } from "./CatalogSelectionFail.vue?vue&type=template&id=8b00df5e&"
import script from "./CatalogSelectionFail.vue?vue&type=script&lang=ts&"
export * from "./CatalogSelectionFail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports